<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  mounted () {
  }
}
</script>

<style lang="sass">
body
 overflow-x: hidden
</style>
